import type { Intakes } from "gql/api";

export function computeIntakeLabel(
  intake: Partial<Intakes> | undefined | null,
  useHSShaft?: boolean | null | undefined
): string {
  if (!intake) return "";
  return useHSShaft === true
    ? `${intake.manufacturer} / ${intake.intake_type} (HS Shaft)`
    : `${intake.manufacturer} / ${intake.intake_type} (STD Shaft)`;
}
